/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createUsolve } from '../../factoriesAny.js';
export var usolveDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  divideScalarDependencies: divideScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createUsolve: createUsolve
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUsolve.generated.js
// module id = 528
// module chunks = 0